import React, { useState } from 'react';
import './LearnMore.css'; // We'll create this CSS file

const faculties = [
  {
    title: "Health Sciences",
    description:
      "Covers medicine, nursing, clinical associate, and public health fields. Focuses on producing socially accountable, community-oriented health professionals. Entry often requires strong performance in Mathematics, Physical Sciences, and Life Sciences.\n\n📌 *Minimum Requirements: APS 38–48, Mathematics 70%, Physical Sciences 70%, Life Sciences 70%, English 60%+.*",
    icon: "🩺",
    color: "bg-red-50 border-red-200 text-red-800",
  },
  {
    title: "Law, Humanities & Social Sciences",
    description:
      "Focuses on areas like law, social work, development studies, and criminology. Students are trained to understand and solve complex societal and legal issues. Requirements may include strong performance in languages and social sciences.\n\n📌 *Minimum Requirements: APS 28–40, English 60–70%, Mathematical Literacy accepted for BA.*",
    icon: "⚖️",
    color: "bg-indigo-50 border-indigo-200 text-indigo-800",
  },
  {
    title: "Education",
    description:
      "Prepares future educators for primary, secondary, and special education. Emphasis on practical experience in schools. Entry often requires good marks in English and a second language, plus teaching-specific subject combinations.\n\n📌 *Minimum Requirements: APS 23–28, English 50–60%, LO 60%, Math or Math Literacy 40–50%.*",
    icon: "📚",
    color: "bg-blue-50 border-blue-200 text-blue-800",
  },
  {
    title: "Management & Public Administration",
    description:
      "Equips students for careers in government, NGOs, and business leadership. Programmes cover governance, HR, and policy. Requirements typically include proficiency in Mathematics/Math Literacy and languages.\n\n📌 *Minimum Requirements: APS 24–30, English 50–60%, Math or Math Literacy accepted depending on programme.*",
    icon: "💼",
    color: "bg-green-50 border-green-200 text-green-800",
  },
  {
    title: "Engineering, ICT & Built Environment",
    description:
      "Offers qualifications in civil, electrical, mechanical engineering and information technology. Highly technical with strong lab components. Requires strong Mathematics and Physical Sciences marks.\n\n📌 *Minimum Requirements: APS 30–36, Mathematics 70%, Physical Sciences 70%, English 60%.*",
    icon: "⚙️",
    color: "bg-yellow-50 border-yellow-200 text-yellow-800",
  },
  {
    title: "Natural Sciences",
    description:
      "Focuses on biology, chemistry, physics, and environmental sciences. Suitable for careers in research, lab work, and academia. Entry requires solid Mathematics and science subject marks.\n\n📌 *Minimum Requirements: APS 28–34, Mathematics 60–70%, Physical Sciences 60%, English 50–60%.*",
    icon: "🔬",
    color: "bg-purple-50 border-purple-200 text-purple-800",
  },
  {
    title: "Finance & Economics",
    description:
      "Provides knowledge in accounting, auditing, and financial planning. Builds skills for the corporate and financial sectors. Requirements often include strong Mathematics or Accounting marks.\n\n📌 *Minimum Requirements: APS 28–35, Mathematics 60%, Accounting 60%, English 60%.*",
    icon: "💰",
    color: "bg-teal-50 border-teal-200 text-teal-800",
  },
];


const LearnMoreTab = () => {
  const [query, setQuery] = useState('');
  const [expandedCard, setExpandedCard] = useState(null);

  const filteredFaculties = faculties.filter(faculty =>
    faculty.title.toLowerCase().includes(query.toLowerCase()) ||
    faculty.description.toLowerCase().includes(query.toLowerCase())
  );

  const toggleExpand = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  return (
    <div className="learn-more-container">
      <div className="header-section">
        <h1 className="main-title">Explore Academic Fields</h1>
        <p className="subtitle">
          Discover various faculties and what they offer — from career paths to entrance requirements.
        </p>
      </div>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search by field or keyword..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="faculties-grid">
        {filteredFaculties.length > 0 ? (
          filteredFaculties.map((faculty, index) => (
            <div
              key={index}
              className={`faculty-card ${faculty.color} ${expandedCard === index ? 'expanded' : ''}`}
              onClick={() => toggleExpand(index)}
            >
              <div className="card-header">
                <span className="faculty-icon">{faculty.icon}</span>
                <h2 className="faculty-title">{faculty.title}</h2>
              </div>
              <p className="faculty-description">
                {expandedCard === index || faculty.description.length < 150
                  ? faculty.description
                  : `${faculty.description.substring(0, 150)}...`}
              </p>
              {faculty.description.length > 150 && (
                <button className="read-more-btn">
                  {expandedCard === index ? 'Read Less' : 'Read More'}
                </button>
              )}
            </div>
          ))
        ) : (
          <div className="no-results">
            <p>No matches found for "{query}". Try a different search term.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LearnMoreTab;